import {
  ReplyForwardEditorAction,
  ReplyForwardEmailPreview,
} from '../../../type';

export const getDefaultValueForCcBccField = (
  action: ReplyForwardEditorAction,
  selectedEmail: ReplyForwardEmailPreview,
  type: 'cc' | 'bcc',
) => {
  if (action === 'replyAll') {
    if (selectedEmail[type]?.length) {
      return selectedEmail[type];
    }
  }
  return [];
};
